import { render, staticRenderFns } from "./DabiaoLayout.vue?vue&type=template&id=502c4893&scoped=true&"
import script from "./DabiaoLayout.vue?vue&type=script&lang=js&"
export * from "./DabiaoLayout.vue?vue&type=script&lang=js&"
import style0 from "./DabiaoLayout.vue?vue&type=style&index=0&id=502c4893&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502c4893",
  null
  
)

export default component.exports